interface IconProps {
  className?: string;
}

/** Open folder — "reveal this on disk" (Finder / File Explorer). */
export function FolderOpenIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7a2 2 0 012-2h4l2 2h6a2 2 0 012 2v1M3 7v10a2 2 0 002 2h13.5a1.5 1.5 0 001.43-1.04l1.8-5.5A1 1 0 0020.78 11H7.2a2 2 0 00-1.9 1.37L3 19"
      />
    </svg>
  );
}
